import axios from 'axios';

axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

const api = axios.create({
    baseURL: process?.env.NODE_ENV === 'development' ? 'https://hml.gscon.com.br/api/' : '/api/'
});

api.interceptors.request.use(function (request) {
    const token = localStorage.getItem('@Gscon:Token');
    if(token){
        request.headers.Authorization = `Bearer ${token}`;
    }
       return request;
    }, (error) => {
        return Promise.reject(error)

})



export default api; 